import { AppRegistrationSection } from '../../AppRegistrationSection';
import { Button } from 'components/index';
import { Frame } from 'components/organisms';
import { frameConfig } from '../../AppConfig';
import { useRejectedTimer } from './useRejectedTimer';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import Clock from 'assets/svg/clock-circle.svg?react';
import layout from '../../scss/layout.module.scss';
import styles from './RejectedTimer.module.scss';
import Timer from 'components/Timer/Timer';

export default function RejectedTimer() {
  const { t } = useTranslation('rejectedTimer');
  const { loading, showTimer, time, onSubmit } = useRejectedTimer();
  return (
    <Frame
      {...frameConfig}
      sectionID={AppRegistrationSection.Confirmation}
      bodyWrapperClassName={classes(
        layout['width-lg'],
        layout['frame-x-compact'],
        styles['frame-body-wrapper'],
      )}
      hideEditButton
    >
      <div className={styles.layout}>
        <Clock data-testid="rejectedTimer-clock" />
        <div className={styles.title} data-testid="rejectedTimer-title">
          {t('title')}
        </div>

        {showTimer ? (
          <>
            <div className={styles.desc} data-testid="rejectedTimer-desc">
              {t('desc')}
            </div>
            <Timer
              className={styles.timer}
              time={time}
              showDays={Boolean(time?.days)} // more than 24 hours
              showSeconds={false}
            />
          </>
        ) : (
          <div
            className={classes(styles.desc, styles['no-timer'])}
            data-testid="rejectedTimer-no-timer"
          >
            {t('no_timer')}
          </div>
        )}
        <Button
          className={styles.cto}
          onClick={onSubmit}
          dataTest="rejectedTimer-cto"
          loading={loading}
        >
          {t('cto')}
        </Button>
      </div>
    </Frame>
  );
}
